import { Card, CardContent } from '@skylabs-digital/backoffice-kit';
import { TimeSeriesChart } from '@skylabs-digital/backoffice-kit/charts';
import { formatDuration } from '../../lib/format';
import type { ProcessingSeries } from '../../schemas/processing.schema';

const EMPTY = 'Nothing processed in this window';

function timeFormatter(window: ProcessingSeries['window'] | undefined) {
  return (t: string | number) => {
    const d = new Date(t);
    if (window === '7d') return d.toLocaleDateString([], { weekday: 'short', hour: '2-digit' });
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };
}

/** Un solo eje por gráfico: backlog y ETA van separados en vez de un doble eje. */
export function ProcessingCharts({
  series,
  loading,
}: {
  series: ProcessingSeries | null;
  loading: boolean;
}) {
  const points = series?.points ?? [];
  const formatTime = timeFormatter(series?.window);
  const busy = loading && series === null;
  const etaPoints = points.map((p) => ({
    t: p.t,
    etaMinutes: p.etaSeconds === null ? null : Math.round(p.etaSeconds / 60),
  }));
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <Card className="lg:col-span-2">
        <CardContent className="pt-6">
          <TimeSeriesChart
            title="Enqueued vs completed"
            data={points}
            series={[
              { key: 'queued', label: 'Enqueued', type: 'bar' },
              { key: 'completed', label: 'Completed', type: 'bar' },
              { key: 'failed', label: 'Failed', type: 'bar', color: 'hsl(var(--destructive))' },
            ]}
            height={240}
            loading={busy}
            formatTime={formatTime}
            emptyMessage={EMPTY}
          />
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <TimeSeriesChart
            title="Backlog"
            data={points}
            series={[{ key: 'backlog', label: 'Backlog', type: 'area' }]}
            height={200}
            loading={busy}
            formatTime={formatTime}
            emptyMessage={EMPTY}
          />
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <TimeSeriesChart
            title="ETA (minutes)"
            data={etaPoints}
            series={[{ key: 'etaMinutes', label: 'ETA', color: 'hsl(var(--chart-4))' }]}
            height={200}
            loading={busy}
            formatTime={formatTime}
            formatValue={(v) => formatDuration(v * 60)}
            emptyMessage={EMPTY}
          />
        </CardContent>
      </Card>
    </div>
  );
}
